import React, { FunctionComponent } from 'react'
import PuxIcon from 'Shared/components/PuxIcon/PuxIcon'
import PuxTooltip from 'Shared/components/PuxTooltip/PuxTooltip'

interface PlansTableInfoIconProps {
  title: string
}

const PlansTableInfoIcon: FunctionComponent<PlansTableInfoIconProps> = ({
  title,
}) => (
  <PuxTooltip content={title} placement='top'>
    <span
      aria-label={title}
      className='PlansTable-info'
      role='img'
      tabIndex={0}
    >
      <PuxIcon name='user-interface/c-info' size={16} decorative />
    </span>
  </PuxTooltip>
)

export default PlansTableInfoIcon
